import { DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE } from "@/redux/reducers/dashboardPersist";
import type { DashboardPersistReduxActions } from "@/redux/reducers/dashboardPersist";

export const dashboardPersistReduxActions: DashboardPersistReduxActions = {
  setPromissoryPrice(price) {
    return {
      payload: price,
      type: DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE.SET_PROMISSORY_PRICE,
    };
  },
  setTrackingCode(code) {
    return {
      payload: code,
      type: DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE.SET_TRACKING_CODE,
    };
  },
  setShopInfo(name, url) {
    return {
      payload: { name, url },
      type: DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE.SET_SHOP_INFO,
    };
  },
  addTrackingCodeToSetPlanedOrders(trackingCode) {
    return {
      payload: trackingCode,
      type: DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE.ADD_TRACKING_CODE_TO_SET_PLANED_ORDERS,
    };
  },
};
